import React, { useState } from 'react';
import { Banknote, Shield, FileText, Calendar, PiggyBank, Heart, TrendingUp, Zap } from 'lucide-react';
import { Button } from './ui/button';
import { ownerBenefits, tenantBenefits } from '../mock';

const iconMap = {
  Banknote,
  Shield,
  FileText,
  Calendar,
  PiggyBank,
  Heart,
  TrendingUp,
  Zap
};

const Benefits = () => {
  const [activeTab, setActiveTab] = useState('owners');

  const currentBenefits = activeTab === 'owners' ? ownerBenefits : tenantBenefits;
  const tabTitle = activeTab === 'owners' ? 'Beneficios para propietarios' : 'Beneficios para inquilinos';
  const backgroundImage = activeTab === 'owners' 
    ? "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxyZW50YWwlMjBwcm9wZXJ0eXxlbnwwfHx8fDE3NTQ1ODQ0NzJ8MA&ixlib=rb-4.1.0&q=85"
    : "https://images.unsplash.com/photo-1494526585095-c41746248156?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxyZW50YWwlMjBwcm9wZXJ0eXxlbnwwfHx8fDE3NTQ1ODQ0NzJ8MA&ixlib=rb-4.1.0&q=85";

  return (
    <section className="py-24 relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src={backgroundImage}
          alt="Property background"
          className="w-full h-full object-cover transition-all duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-black/60"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-green-900/20 via-transparent to-green-900/30"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Tab Selector */}
        <div className="text-center mb-16">
          <div className="inline-flex bg-black/30 backdrop-blur-sm rounded-full p-2 mb-8">
            <Button
              onClick={() => setActiveTab('owners')}
              className={`px-8 py-3 rounded-full text-white font-semibold transition-all duration-300 ${
                activeTab === 'owners' 
                  ? 'bg-green-600 shadow-lg' 
                  : 'bg-transparent hover:bg-white/10'
              }`}
            >
              Propietarios
            </Button>
            <Button
              onClick={() => setActiveTab('tenants')}
              className={`px-8 py-3 rounded-full text-white font-semibold transition-all duration-300 ${
                activeTab === 'tenants' 
                  ? 'bg-green-600 shadow-lg' 
                  : 'bg-transparent hover:bg-white/10'
              }`}
            >
              Inquilinos
            </Button>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {tabTitle}
          </h2>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            {activeTab === 'owners' 
              ? 'Maximiza tus beneficios como propietario con nuestro sistema innovador'
              : 'Ahorra significativamente mientras disfrutas de estabilidad total'
            }
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {currentBenefits.map((benefit, index) => {
            const IconComponent = iconMap[benefit.icon];
            
            return (
              <div 
                key={benefit.title}
                className="group bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/20 hover:border-green-400/50 transform hover:-translate-y-2 transition-all duration-300"
              >
                <div className="w-12 h-12 bg-green-500/20 rounded-xl flex items-center justify-center mb-4 group-hover:bg-green-600 transition-colors duration-300">
                  <IconComponent className="w-6 h-6 text-green-400 group-hover:text-white transition-colors duration-300" />
                </div>
                
                <h3 className="text-lg font-bold text-white mb-2">
                  {benefit.title}
                </h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;